import CPageModule from '../../../components/CPageModule';
import CLocalizedText from '../../../components/CLocalizedText';
import CStatefulContainer from '../../../components/CStatefulContainer';
import CPageModulePlot from '../../../components/CPageModulePlot';
import React, { useState } from 'react';
import type { IResponseTableOrPlot } from '../../../models/IResponseTableOrPlot';
import type { PlotlyResponse } from '../../../models/PlotlyModel';
import CTab from '../../../components/CTab';
import CTabItem from '../../../components/CTabItem';
import CModal from '../../../components/CModal';
import { updateStateAttribute } from '../../../helpers/helper';
import CTextFieldDisplay from '../../../components/CTextFieldDisplay';
import CLocalizedTextString from '../../../components/CLocalizedTextString';

interface Props {
  plotSimulation: IResponseTableOrPlot<{
    call: PlotlyResponse, put: PlotlyResponse, call_payoff: number, put_payoff: number
  }>;
}

interface State {
  showModal: boolean,
}

export default function CCalculatorSimulation(props: Props) {
  const [state, setState] = useState<State>({ showModal: false });

  const callLabel = CLocalizedTextString('topics.calculator.page.call');
  const putLabel = CLocalizedTextString('topics.calculator.page.put');

  const cLocalizedTextStringPut = CLocalizedTextString('topics.calculator.page.put');
  const cLocalizedTextStringCall = CLocalizedTextString('topics.calculator.page.call');

  return (<CPageModule fullWidth>
    <CPageModule submodule>
      <h3><CLocalizedText dictKey={'topics.calculator.simulation.heading'} /></h3>
    </CPageModule>
    <CStatefulContainer apiRequestState={props.plotSimulation.state} submodule>
      <CTab submodule>
        <CTabItem label={'call'} text={cLocalizedTextStringCall}>
          <CPageModulePlot data={props.plotSimulation.data?.call.data}
                           layout={props.plotSimulation.data?.call.layout}
          />
        </CTabItem>
        <CTabItem label={'put'} text={cLocalizedTextStringPut}>
          <CPageModulePlot data={props.plotSimulation.data?.put.data}
                           layout={props.plotSimulation.data?.put.layout}
          />
        </CTabItem>
      </CTab>
    </CStatefulContainer>
    <CPageModule submodule showContent={!!props.plotSimulation.data && !props.plotSimulation.state.isError}>
      <CLocalizedText dictKey={'topics.calculator.simulation.payoffDesc.preview'}
                      onClickReadMore={() => {
                        updateStateAttribute<State>({ showModal: true }, setState);
                      }}
                      collapsible />
    </CPageModule>
    <CModal open={state.showModal} onClose={() => {
      updateStateAttribute<State>({ showModal: false }, setState);
    }}
    >
      <CPageModule fullWidth style={{ paddingTop: 0, paddingBottom: 0 }}>
        <CLocalizedText dictKey={'topics.calculator.simulation.payoffDesc'} />
        <div className={'flex gap-8 justify-center'}>
          <CTextFieldDisplay label={callLabel}>
            {props.plotSimulation.data?.call_payoff.toFixed(4)}
          </CTextFieldDisplay>
          <CTextFieldDisplay label={putLabel}>
            {props.plotSimulation.data?.put_payoff.toFixed(4)}
          </CTextFieldDisplay>
        </div>
      </CPageModule>
    </CModal>
  </CPageModule>);
}
